import CollectionGalleryWithCounterView from "@components/molecules/CollectionGalleryWithCounterView/CollectionGalleryWithCounterView";
import GalleryWithCounterView from "@components/molecules/GalleryWithCounterView/GalleryWithCounterView";
import styled, { DefaultTheme } from "styled-components/native";
import { GalleryHeaderComponentViewProps } from "./types";
import { Platform } from "react-native";
import { css } from "styled-components/native";
import { useFindMatch } from "@scenes/findMatch/FindMatchContext";

const GalleryHeaderComponentView = ({
  containerWidth,
}: GalleryHeaderComponentViewProps) => {
  const {
    theme,
    itemDetail,
    otherDetail,
    currentIndex,
    productType,
    productColor,
  } = useFindMatch();
  return (
    <PriceDetailContainer>
      <FlexMainView>
        <MainContainerView testID="findMatch.gallery.primary">
          <LeftLabelContainer padding={theme.isMobile ? 10 : 20}>
            <GalleryWithCounterView
              containerWidth={containerWidth}
              ReceivedMedia={itemDetail?.media ?? []}
              OtherMedia={otherDetail?.[currentIndex as number]}
              image_thumb_url={itemDetail?.image_thumb_url}
              applyRadius={true}
              productType={productType}
              itemDetail={itemDetail}
              extraSmallImage={true}
              ceterIconTheme={
                theme[productColor as keyof DefaultTheme] as string
              }
              isPrimary={true}
              testIDPrefix="findMatch.gallery.primary"
            />
          </LeftLabelContainer>
        </MainContainerView>
        <GapView />
        <MainContainerView
          location={"right"}
          testID="findMatch.gallery.secondary"
        >
          <LeftLabelContainer padding={theme.isMobile ? 10 : 20}>
            <CollectionGalleryWithCounterView
              containerWidth={containerWidth}
              OtherMedia={otherDetail}
              ReceivedMedia={itemDetail}
              itemIndex={currentIndex}
              applyRadius={true}
              productType={productType}
              extraSmallImage={true}
              ceterIconTheme={
                theme[productColor as keyof DefaultTheme] as string
              }
              testIDPrefix="findMatch.gallery.secondary"
            />
          </LeftLabelContainer>
        </MainContainerView>
      </FlexMainView>
    </PriceDetailContainer>
  );
};

const PriceDetailContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  ${({ theme }) =>
    Platform.OS !== "web" &&
    theme.isMobile &&
    css`
      flex: 1;
    `}
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  width: 50%;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      flex: 1;
    `}
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  flex-basis: auto;
`;

const LeftLabelContainer = styled.View<any>`
  flex-direction: row;
  margin: 10px 0;
`;

const GapView = styled.View`
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      width: 30px;
    `}
`;

export default GalleryHeaderComponentView;
